/*
  ZOURETTI (Stap 4) — gratis-verzendbalk in de winkelwagen, andere valuta.

  De server (snippets/custom-cart-threshold.liquid) rekent alles uit in de
  winkelvaluta (EUR) en toont de balk direct. Winkelt de bezoeker in een andere
  valuta (bijv. PLN), dan laat de server de balk verborgen en rekent dit script
  de drempel om met de koers van Shopify (window.Shopify.currency.rate).
  Geen koers beschikbaar = de balk blijft verborgen. Nooit een verkeerd bedrag.

  Het thema bouwt de winkelwagen na elke wijziging opnieuw op; data-stamp
  verandert dan, en het element rekent zichzelf opnieuw uit.

  <zr-threshold> (landen en valuta, 29-09): het drempelbedrag in teksten met
  [threshold] (aankondigingsbalk, USP-regels, verzenddatum-balk, regel onder de
  afrekenknop). Zelfde koers, maar naar BOVEN afgerond op een rond bedrag
  (R 1,481 wordt R 1,500). Het getoonde bedrag is dus nooit lager dan de echte
  drempel. Geen koers = het euro-bedrag blijft staan.
*/
(function () {
  if (customElements.get('zr-free-shipping')) return;

  /* Zelfde notatie als de rest van de winkel, bijv. "200,56 zł". */
  function formatMoney(cents, format, currency) {
    const value = cents / 100;
    const build = (decimals, thousands, decimal) => {
      const [whole, fraction] = value.toFixed(decimals).split('.');
      const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return fraction ? grouped + decimal + fraction : grouped;
    };
    const formats = {
      amount: () => build(2, ',', '.'),
      amount_no_decimals: () => build(0, ',', '.'),
      amount_with_comma_separator: () => build(2, '.', ','),
      amount_no_decimals_with_comma_separator: () => build(0, '.', ','),
      amount_with_space_separator: () => build(2, ' ', ','),
      amount_no_decimals_with_space_separator: () => build(0, ' ', ','),
      amount_with_period_and_space_separator: () => build(2, ' ', '.'),
      amount_with_apostrophe_separator: () => build(2, "'", '.'),
    };
    const match = /\{\{\s*(\w+)\s*\}\}/.exec(format || '');
    if (match && formats[match[1]]) return format.replace(match[0], formats[match[1]]());
    return build(2, ',', '.') + ' ' + currency;
  }

  class ZrFreeShipping extends HTMLElement {
    static get observedAttributes() {
      return ['data-stamp', 'data-total'];
    }

    connectedCallback() {
      this.schedule();
    }

    attributeChangedCallback() {
      this.schedule();
    }

    schedule() {
      if (this.queued) return;
      this.queued = true;
      queueMicrotask(() => {
        this.queued = false;
        this.update();
      });
    }

    update() {
      const data = this.dataset;
      if (!data.currency || data.currency === data.shopCurrency) return;

      const currency = window.Shopify && window.Shopify.currency;
      const rate = currency ? parseFloat(currency.rate) : NaN;
      if (!currency || currency.active !== data.currency || !(rate > 0)) return;

      const total = parseInt(data.total, 10) || 0;
      const threshold = Math.round((parseInt(data.threshold, 10) || 0) * rate);
      if (!(threshold > 0)) return;

      const text = this.querySelector('.zr-fs__text');
      const track = this.querySelector('.zr-fs__track');
      const fill = this.querySelector('.zr-fs__fill');
      if (!text || !track || !fill) return;

      const remaining = threshold - total;
      const progress = Math.min(100, Math.max(0, (total / threshold) * 100));

      text.textContent = '';
      if (remaining > 0) {
        const amount = formatMoney(remaining, data.moneyFormat, data.currency);

        (data.text || '').split(/\[bedrag\]|\[amount\]/).forEach((part, index) => {
          if (index > 0) {
            const strong = document.createElement('strong');
            strong.className = 'zr-fs__amount';
            strong.textContent = amount;
            text.append(strong);
          }
          text.append(document.createTextNode(part));
        });
      } else {
        text.textContent = data.textReached || '';
      }

      fill.style.width = progress.toFixed(1) + '%';
      track.setAttribute('aria-valuenow', String(Math.round(progress)));
      track.setAttribute('aria-label', text.textContent);
      this.hidden = false;
    }
  }

  customElements.define('zr-free-shipping', ZrFreeShipping);

  /* Rond bedrag, altijd naar boven: 87,40 → 88 · 128 → 130 · 1.481 → 1.500. */
  function roundUpNicely(cents) {
    const units = cents / 100;
    let step = 1;
    if (units >= 100000) step = 5000;
    else if (units >= 10000) step = 500;
    else if (units >= 1000) step = 50;
    else if (units >= 100) step = 5;
    return Math.ceil(units / step) * step * 100;
  }

  /* Zoals money_without_trailing_zeros: "R 1,500.00" → "R 1,500". */
  function withoutTrailingZeros(text) {
    return text.replace(/[.,]00(?!\d)/, '');
  }

  class ZrThreshold extends HTMLElement {
    static get observedAttributes() {
      return ['data-stamp'];
    }

    connectedCallback() {
      this.update();
    }

    attributeChangedCallback() {
      this.update();
    }

    update() {
      const data = this.dataset;
      const currency = window.Shopify && window.Shopify.currency;
      const rate = currency ? parseFloat(currency.rate) : NaN;
      if (!currency || currency.active !== data.currency || !(rate > 0)) return;

      const cents = Math.round((parseInt(data.cents, 10) || 0) * rate);
      if (!(cents > 0)) return;

      const text = withoutTrailingZeros(formatMoney(roundUpNicely(cents), data.moneyFormat, data.currency));
      if (this.textContent !== text) this.textContent = text;
    }
  }

  customElements.define('zr-threshold', ZrThreshold);
})();